import { Injectable } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import {
  ScrollInvalidDirective,
  FormGroupWithName
} from '../directives/scroll-invalid.directive';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class FormAllFieldsValidationService {
  private _subForms: UntypedFormGroup[] = [];
  private scrollInvalidDirective: ScrollInvalidDirective[] = [];

  constructor(router: Router) {
    router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        this._subForms = [];
        this.scrollInvalidDirective = [];
      }
    });
  }

  setScrollInvalidDirective(scrollInvalidDirective: ScrollInvalidDirective) {
    if (scrollInvalidDirective) {
      this.scrollInvalidDirective.push(scrollInvalidDirective);
    }

    this.scrollInvalidDirective.sort(
      (a, b) => parseInt(a.scrollPriority, 0) - parseInt(b.scrollPriority, 0)
    );
  }

  validation(formGroup: UntypedFormGroup) {
    formGroup.markAsDirty();
    formGroup.markAsTouched();

    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormGroup) {
        this.validation(control);
      }
      if (control instanceof UntypedFormArray) {
        control.controls.forEach(c => this.validation(c as UntypedFormGroup));
      } else {
        control.markAsDirty();
        control.markAsTouched();
      }
    });
  }

  addSubForms(subForm: UntypedFormGroup) {
    this._subForms.push(subForm);
  }

  validationAllForms(formGroup: UntypedFormGroup) {
    this.validation(formGroup);

    if (this._subForms) {
      this._subForms.forEach(subForm => {
        this.validation(subForm);
      });
    }

    if (this.scrollInvalidDirective) {
      const formName = (<FormGroupWithName>formGroup).formName;
      this.scrollInvalidDirective.forEach((d, index) => {
        if (
          formName === d.formName &&
          (index === 0 || !this.scrollInvalidDirective[index - 1].isInvalid)
        ) {
          d.scrollToInvalidElement(formName);
        }
      });
    }
  }
}
